module.exports = __webpack_public_path__ + "assets/img/nike.8cd80cf7.svg";